import {
  FormControl,
  FormLabel,
  Box,
  Text,
  CircularProgress,
  Select,
  Alert,
  AlertIcon,
} from "@chakra-ui/react";
import Swal from "sweetalert2";
import api from "services/api";
import MaterialTable from "material-table";
import { tableIcons } from "utils/tableIcons";
import { ReactNode, useEffect, useState } from "react";
import { useAuth } from "hooks/useAuth";
import { sortDESC } from "utils/sort";

interface Entidade {
  id: number;
  nm_entidade: string;
  contatoes: {
    id: number;
    nm_contato: string;
    telefone_contato: string;
    email_contato: string;
  };
}

interface Operadora {
  setor: any;
  email_contato: ReactNode;
  telefone_contato: ReactNode;
  nm_contato: ReactNode;
  id: number;
  nm_operadora: string;
}

interface Contatos {
  id: number;
  nm_contato: string;
  telefone_contato: string;
  email_contato: string;
  setor: number;
}

interface Setores {
  id: number;
  nm_setor: string;
}

const ContatosPortal = () => {
  const [entidades, setEntidades] = useState<Entidade[]>([]);
  const [operadoras, setOperadoras] = useState<Operadora[]>([]);
  const [contatos, setContatos] = useState<Contatos[]>([]);
  const [setores, setSetores] = useState<Setores[]>([]);
  const [tipoContato, setTipoContato] = useState("");
  const [cont, setCont] = useState();
  const [choice, setChoice] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const [formLoading, setFormLoading] = useState(false);
  const { user } = useAuth();

  async function getContatos(id: string) {
    if (id) {
      setFormLoading(true);
      try {
        if (tipoContato === "operadora") {
          const response = await api.get(`/operadoras?id=${id}`);
          setContatos(response.data[0].contatoes.sort(sortDESC));
        } else if (tipoContato === "entidade") {
          const response = await api.get(`/entidades?id=${id}`);
          setContatos(response.data[0].contatoes.sort(sortDESC));
        }
      } catch (err) {
        console.log(err);
        setPageLoading(false);
        Swal.fire({
          icon: "error",
          title: `Erro ao listar os contatos da ${
            tipoContato === "operadora"
              ? "operadora"
              : tipoContato === "entidade" && "entidade"
          }`,
          showConfirmButton: true,
          confirmButtonText: `Ok`,
        });
      }
      setFormLoading(false);
    }
  }

  useEffect(() => {
    async function getCont() {
      try {
        const response = await api.get("/contatoes");
        setCont(response.data.length);
        setPageLoading(false);
      } catch (err) {
        console.log(err);
        setPageLoading(false);
        Swal.fire({
          icon: "error",
          title: "Erro ao listar os contatos",
          showConfirmButton: true,
          confirmButtonText: `Ok`,
        });
      }
    }

    async function getEntidades() {
      try {
        const response = await api.get("/entidades?_sort=nm_entidade:ASC");
        setEntidades(response.data);
        setPageLoading(false);
      } catch (err) {
        console.log(err);
        setPageLoading(false);
        Swal.fire({
          icon: "error",
          title: "Erro ao listar as entidades",
          showConfirmButton: true,
          confirmButtonText: `Ok`,
        });
      }
    }

    async function getOperadoras() {
      try {
        const response = await api.get("/operadoras?_sort=nm_operadora:ASC");
        setOperadoras(response.data);
        setPageLoading(false);
      } catch (err) {
        console.log(err);
        setPageLoading(false);
        Swal.fire({
          icon: "error",
          title: "Erro ao listar as operadoras",
          showConfirmButton: true,
          confirmButtonText: `Ok`,
        });
      }
    }

    async function getSetores() {
      try {
        const response = await api.get("/setors");
        setSetores(response.data);
        setPageLoading(false);
      } catch (err) {
        console.log(err);
        setPageLoading(false);
        Swal.fire({
          icon: "error",
          title: "Erro ao listar os setores",
          showConfirmButton: true,
          confirmButtonText: `Ok`,
        });
      }
    }

    getCont();
    getSetores();
    getOperadoras();
    getEntidades();
  }, [user]);

  if (pageLoading) {
    return (
      <Box
        as="section"
        display="flex"
        w="100%"
        justifyContent="center"
        alignItems="center"
      >
        <CircularProgress isIndeterminate color="blue.200" />
      </Box>
    );
  }

  return (
    <Box
      as="section"
      display="flex"
      flexDir="column"
      w="100%"
      maxHeight="calc(100vh - 72px)"
      overflow="auto"
      pb="4"
    >
      <Box
        display="flex"
        flexDirection="column"
        gridRowGap="15px"
        width="300px"
        padding="15px"
        margin="15px"
        backgroundColor="#fff"
        boxShadow="0px 3px 3px -2px rgb(0 0 0 / 20%),
    0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%)"
      >
        {cont && cont > 0 ? (
          <FormControl>
            <FormLabel htmlFor="setor">Tipo de contato</FormLabel>
            <Select
              placeholder="Selecione um tipo"
              id="setor"
              name="setor"
              type="text"
              onChange={(e) => {
                setTipoContato(e.target.value);
                setChoice(false);
              }}
              value={tipoContato}
            >
              <option value="operadora">Operadora</option>
              <option value="entidade">Pessoa Jurídica</option>
            </Select>
          </FormControl>
        ) : (
          <Alert status="info">
            <AlertIcon />
            Nenhum contato indicado!
          </Alert>
        )}

        {tipoContato && tipoContato === "entidade" && (
          <FormControl>
            <FormLabel htmlFor="entidade">Pessoa Jurídica</FormLabel>
            <Select
              placeholder="Selecione uma pessoa jurídica"
              id="entidade"
              name="entidade"
              type="text"
              onChange={(e) => {
                if (e.target.value) {
                  setChoice(true);
                }
                getContatos(e.target.value);
              }}
            >
              {entidades &&
                entidades.map((entidade) => (
                  <option key={entidade.id} value={entidade.id}>
                    {entidade.nm_entidade}
                  </option>
                ))}
            </Select>
          </FormControl>
        )}

        {tipoContato && tipoContato === "operadora" && (
          <FormControl>
            <FormLabel htmlFor="operadora">Operadora</FormLabel>
            <Select
              placeholder="Selecione uma operadora"
              id="operadora"
              name="operadora"
              type="text"
              onChange={(e) => {
                if (e.target.value) {
                  setChoice(true);
                }
                getContatos(e.target.value);
              }}
            >
              {operadoras &&
                operadoras.map((operadora) => (
                  <option key={operadora.id} value={operadora.id}>
                    {operadora.nm_operadora}
                  </option>
                ))}
            </Select>
          </FormControl>
        )}
      </Box>

      {contatos && tipoContato && choice && !formLoading ? (
        <Box as="form" paddingInline="4">
          <MaterialTable
            icons={tableIcons}
            title="Contatos"
            data={contatos}
            localization={{
              body: {
                emptyDataSourceMessage: "Nenhum contato cadastrado.",
              },
              pagination: {
                labelDisplayedRows: "{from}-{to} de {count}",
                labelRowsSelect: "linhas",
                previousTooltip: "Página anterior",
                nextTooltip: "Próxima página",
                firstTooltip: "Primeira página",
                lastTooltip: "Última página",
              },
              toolbar: {
                searchPlaceholder: "Procurar",
              },
            }}
            options={{ emptyRowsWhenPaging: false, tableLayout: "auto" }}
            columns={[
              {
                title: "Nome",
                field: "nm_contato",
                cellStyle: {
                  width: "25%",
                },
                render: (element) => {
                  return <Text as="p">{element.nm_contato}</Text>;
                },
              },
              {
                title: "Telefone",
                field: "telefone_contato",
                cellStyle: {
                  width: "25%",
                },
                render: (element) => {
                  return (
                    <Text as="p">
                      {[
                        element?.telefone_contato?.slice(0, 0),
                        "(",
                        element?.telefone_contato?.slice(0, 2),
                        ") ",
                        element?.telefone_contato?.slice(2),
                      ].join("")}
                    </Text>
                  );
                },
              },
              {
                title: "E-mail",
                field: "email_contato",
                cellStyle: {
                  width: "25%",
                },
                render: (element) => {
                  return <Text as="p">{element.email_contato}</Text>;
                },
              },
              {
                title: "Setor",
                field: "setor",
                cellStyle: {
                  width: "25%",
                },
                render: (element) => {
                  return (
                    <Text>
                      {setores &&
                        setores.map(
                          (item) => item.id === element.setor && item.nm_setor,
                        )}
                    </Text>
                  );
                },
              },
            ]}
          />
        </Box>
      ) : (
        tipoContato &&
        choice && (
          <Box
            as="section"
            display="flex"
            w="100%"
            h="200px"
            justifyContent="center"
            alignItems="center"
          >
            <CircularProgress isIndeterminate color="blue.200" />
          </Box>
        )
      )}
    </Box>
  );
};

export default ContatosPortal;
